import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from "@reduxjs/toolkit";

import SPECIES from "#/model/SpeciesCodeList.js";
import ApiClient from "#/redux/api/ApiClient";

const initialState = {
  page: { content: [], totalElements: 0, totalPages: 0, number: 0, size: 10 },
  isLoading: false,
  error: null,
  lastQuery: null,
  list: [],
};

export const fetchBreedPage = createAsyncThunk(
  "breedCodeList/fetchPage",
  async ({ page, filter, sort }, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.get(
        `/api/pasme/pasma/page`,
        null,
        page,
        filter,
        sort,
        false
      );
      return response.data;
    } catch (e) {
      return rejectWithValue(
        e?.response?.data ?? e?.message ?? "fetchBreedPage failed"
      );
    }
  }
);

const breedCodeListSlice = createSlice({
  name: "breedCodeListSlice",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchBreedPage.pending, (state, action) => {
        state.isLoading = true;
        state.error = null;
        // state.lastQuery = action.meta.arg ?? null;
      })
      .addCase(fetchBreedPage.fulfilled, (state, action) => {
        state.isLoading = false;
        state.page = action.payload;
        state.list = action.payload?.content;
      })
      .addCase(fetchBreedPage.rejected, (state, action) => {
        state.isLoading = false;
        state.error =
          action.payload ?? action.error?.message ?? "Unknown error";
      });
  },
});

export default breedCodeListSlice.reducer;

export const SHEEP_GOAT_BREED_CODES = createSelector(
  (state) => state.breedCodeList?.page?.content || [],
  (breeds) =>
    breeds?.filter((b) =>
      [SPECIES.GOAT.id, SPECIES.SHEEP.id].includes(b?.species)
    )
);
export const PIG_BREEDS_LIST = createSelector(
  (state) => state.breedCodeList?.page?.content || [],
  (breeds) => breeds?.filter((breed) => breed?.species === SPECIES.PIG.id) || []
);
